import PropTypes from "prop-types";
import React from "react";
import classNames from "classnames";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Item = function Item(_ref) {
  var children = _ref.children,
      className = _ref.className,
      testSection = _ref.testSection,
      props = _objectWithoutProperties(_ref, ["children", "className", "testSection"]);

  return React.createElement("div", _extends({
    "data-test-section": testSection,
    className: classNames("oui-form-field__item", className)
  }, props), children);
};

Item.propTypes = {
  children: PropTypes.node.isRequired,

  /** CSS class names. */
  className: PropTypes.string,
  testSection: PropTypes.string
};
export default Item;